import React from "react";

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Modal,
  Button,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// actions
import { loginUser, apiError, agreement, agreementCheckbox } from "../../store/actions";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/logo.svg";
import wookAiImg from "../../assets/images/WookAI.png";
import bgcircle from "../../assets/images/bg-circle.png";
import bubble from "../../assets/images/cloud-bubble.png";
import bubbleMobile from "../../assets/images/cloud-mobile.png";
import animateLogo from "../../assets/images/animatelogo.gif";
import animateLogo2 from "../../assets/images/wookai-2.gif";
import circleLogo from "../../assets/images/bg-circle.png";
import "./style.css";

class Login extends React.Component {
  /**
   * component state
   */
  state = {
    email: "",
    password: ""
  };

  // handleValidSubmit
  handleValidSubmit = (event, values) => {
    this.props.loginUser(values, this.props.history);
  };

  handleAgreementSubmit = () => {
    const { email, password } = this.state;
     this.props.loginUser({
      email,password
     }, this.props.history);
  }

  /**
   * close Modal
   */
  closeModal = () => {
    this.props.agreement(false)
  };

  handleAgreementCheckbox = () => {
    const {isAgree} = this.props;
    this.props.agreementCheckbox(!isAgree);
  }

  render() {
    const { email, password } = this.state;
    const { isAgree, isModal } = this.props;

    return (
      <React.Fragment>
        <Modal className="licenseAgreement" isOpen={isModal} toggle={() => this.closeModal} size="xl">
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myModalLabel">
              End User License Agreement
            </h5>
            <button
              type="button"
              onClick={() => this.closeModal()}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Row>
              <Col md="12">
                <p>
                  This End User License Agreement ("<strong>Agreement</strong>")
                  is a binding agreement between you ("<strong>End User</strong>
                  " or "<strong>you</strong>") and WookAI, LLC ("
                  <strong>Company</strong>"). This Agreement governs your use of
                  the cloud-based WookAI software program, platform, and
                  database (together with all related documentation, the "
                  <strong>Software</strong>"). The Software is licensed, not
                  sold, to you.
                </p>
                <p>
                  BY [CLICKING THE "AGREE" BUTTON], YOU (A) ACKNOWLEDGE THAT YOU
                  HAVE READ AND UNDERSTAND THIS AGREEMENT; (B) REPRESENT THAT
                  YOU ARE OF LEGAL AGE TO ENTER INTO A BINDING AGREEMENT; AND
                  (C) ACCEPT THIS AGREEMENT AND AGREE THAT YOU ARE LEGALLY BOUND
                  BY ITS TERMS. IF YOU DO NOT AGREE TO THESE TERMS, DO NOT
                  ACCESS OR USE THE SOFTWARE. AND DELETE IT FROM ANY COMPUTER,
                  SYSTEM, OR DEVICE.
                </p>
                <ol>
                  <li>
                    <strong>License Grant:-</strong>Subject to the terms of this
                    Agreement, Company grants you a limited, non-exclusive, and
                    nontransferable license to access, stream, download (to the
                    extent necessary and applicable), and use the Content and
                    Services (as defined in Section 6) made available in or
                    otherwise accessible through the Software, strictly in
                    accordance with this Agreement, the Software's
                    documentation, and the Terms of Use applicable to such
                    Content and Services as set forth in Section 6.
                  </li>
                  <li>
                    <strong>License Restrictions:-</strong>You shall not:
                    <ol type="a">
                      <li>
                        copy the Software, except as expressly permitted by
                        this license;
                      </li>
                      <li>
                        modify, translate, adapt, or otherwise create derivative
                        works or improvements, whether or not patentable, of the
                        Software;
                      </li>
                      <li>
                        reverse engineer, disassemble, decompile, decode, or
                        otherwise attempt to derive or gain access to the source
                        code of the Software or any part thereof;
                      </li>
                      <li>
                        (d)remove, delete, alter, or obscure any trademarks or
                        any copyright, trademark, patent, or other intellectual
                        property or proprietary rights notices from the
                        Software, including any copy thereof;
                      </li>
                      <li>
                        rent, lease, lend, sell, sublicense, assign, distribute,
                        publish, transfer, or otherwise make available the
                        Software, or any features or functionality of the
                        Software, to any third party for any reason.
                      </li>
                      <li>
                        (f)remove, disable, circumvent, or otherwise create or
                        implement any workaround to any copy protection, rights
                        management, or security features in or protecting the
                        Software; or{" "}
                      </li>
                      <li>
                        use the Software in, or in association with, the design,
                        construction, maintenance, or operation of any hazardous
                        environments or systems, including any power generation
                        systems; aircraft navigation or communication systems,
                        air traffic control systems, or any other transport
                        management systems; safety-critical applications,
                        including medical or life-support systems, vehicle
                        operation applications or any police, fire, or other
                        safety response systems; and military or aerospace
                        applications, weapons systems, or environments.
                      </li>
                    </ol>
                  </li>
                  <li>
                    <strong>Payment and Fees:-</strong>You agree to timely pay all
                    fees due. Payment obligations are non-cancellable, and fees
                    paid are non-refundable.{" "}
                  </li>
                  <li>
                    <strong>Reservation of Rights:-</strong>You acknowledge and
                    agree that the Software is provided under license, and not
                    sold, to you. You do not acquire any ownership interest in
                    the Software under this Agreement, or any other rights
                    thereto other than to use the Software in accordance with
                    the license granted, and subject to all terms, conditions,
                    and restrictions, under this Agreement. Company and its
                    licensors and service providers reserve and shall retain
                    their entire right, title, and interest in and to the
                    Software, including all copyrights, trademarks, and other
                    intellectual property rights therein or relating thereto,
                    except as expressly granted to you in this Agreement.
                  </li>
                  <li>
                    <strong>Collection and Use of Your Information:-</strong>You
                    acknowledge that when you download, install, or use the
                    Software, Company may use automatic means (including, for
                    example, cookies and web beacons) to collect information
                    about your use of the Software, including without limitation
                    devices or systems used to access the Software, your data
                    that is provided for use with the Software, and third party
                    data you access and use in connection with the use of the
                    Software. You also may be required to provide certain
                    information about yourself as a condition to accessing,
                    downloading, installing, or using the Software or certain of
                    its features or functionality, and the Software may provide
                    you with opportunities to share information about yourself
                    with others. All information we collect through or in
                    connection with this Software is subject to our Privacy
                    Policy accessible at <a href="#">www.wookai.com</a> (“
                    <strong>Privacy Policy</strong>”). By downloading,
                    installing, using, and providing information to or through
                    this Software, you consent to all actions taken by us with
                    respect to your information in compliance with the Privacy
                    Policy.
                  </li>
                  <li>
                    <strong>Content and Services:-</strong>The Software may
                    provide you with access to Company's website located at{" "}
                    <a href="#">wookai.com</a> (the "<strong>Website</strong>")
                    and products and services accessible through the Website,
                    and certain features, functionality, and content accessible
                    on or through the Software may be hosted on the Website
                    (collectively, "<strong>Content and Services</strong>").
                    Your access to and use of such Content and Services are
                    governed by Website's Terms of Use located at www.wookai.com
                    and the Privacy Policy, which are incorporated into this
                    Agreement by this reference. Your access to and use of such{" "}
                    <strong>Content and Services</strong> may require you to
                    acknowledge your acceptance of such Terms of Use and Privacy
                    Policy and/or to register with the <strong>Website</strong>,
                    and your failure to do so may restrict you from accessing or
                    using certain of the Software's features and functionality.
                    Any violation of such Terms of Use will also be deemed a
                    violation of this Agreement.
                  </li>
                  <li>
                    <strong>Geographic Restrictions:-</strong>The Content and
                    Services are based in the state of Florida in the United
                    States and provided for access and use only by persons
                    located in the United States. You acknowledge that you may
                    not be able to access all or some of the Content and
                    Services outside of the United States and that access
                    thereto may not be legal by certain persons or in certain
                    countries. If you access the Content and Services from
                    outside the United States, you are responsible for
                    compliance with local laws.
                  </li>
                  <li>
                    <strong>Updates:-</strong>Company may from time to time in its
                    sole discretion develop and provide Software updates, which
                    may include upgrades, bug fixes, patches, other error
                    corrections, and/or new features (collectively, including
                    related documentation, "<strong>Updates</strong>"). Updates
                    may also modify or delete in their entirety certain features
                    and functionality. You agree that Company has no obligation
                    to provide any Updates or to continue to provide or enable
                    any particular features or functionality. To the extent
                    necessary, you shall promptly download and install all
                    Updates and acknowledge and agree that the Software or
                    portions thereof may not properly operate should you fail to
                    do so. You further agree that all Updates will be deemed
                    part of the Software and be subject to all terms and
                    conditions of this Agreement.
                  </li>
                  <li>
                    <strong>Third-Party Materials and Services:-</strong>
                    <ol type="a">
                      <li>
                        The Software may display, include, or make available
                        third-party content (including data, information,
                        applications, and other products, services, and/or
                        materials) or provide links to third-party websites or
                        services, including through third-party advertising
                        ("Third-Party Materials"). You acknowledge and agree
                        that Company is not responsible for Third-Party
                        Materials, including their accuracy, completeness,
                        timeliness, validity, copyright compliance, legality,
                        decency, quality, or any other aspect thereof. Company
                        does not assume and will not have any liability or
                        responsibility to you or any other person or entity for
                        any <strong>Third-Party Materials</strong>, including
                        without limitation any ordering, pricing, or other
                        business decisions you make based on such Third-Party
                        Materials. Third-Party Materials and links thereto are
                        provided solely as a convenience to you, and you access
                        and use them entirely at your own risk and subject to
                        such third parties' terms and conditions.{" "}
                      </li>
                      <li>
                        (b)The Company contracts with third parties to host the
                        Software on sites appropriate for hosting commercial
                        applications and software. You acknowledge and agree
                        that Company is not responsible for any outages or
                        interruptions in access to the service in the
                        third-party hosting sites. Nothing in the Section 9
                        limits or restricts the breadth of the disclaimers and
                        limitations sect forth in Sections 11 and 12 of the
                        Agreement.{" "}
                      </li>
                    </ol>
                  </li>
                  <li>
                    <strong>Term and Termination:-</strong>
                    <ol type="a">
                      <li>
                        The term of Agreement commences when you acknowledge
                        your acceptance and will continue in effect until
                        terminated by you or Company as set forth in this
                        Section 10.
                      </li>
                      <li>
                        You may terminate this Agreement by notifying the
                        Company and deleting all access to the Software.
                      </li>
                      <li>
                        Company may terminate this Agreement at any time
                        without notice if it ceases to support the Software,
                        which Company may do in its sole discretion. In
                        addition, this Agreement will terminate immediately and
                        automatically without any notice if you violate any of
                        the terms and conditions of this Agreement.
                      </li>
                      <li>
                        <strong>Upon termination:-</strong>
                        <ol type="I">
                          <li>
                            all rights granted to you under this Agreement will
                            also terminate; and
                          </li>
                          <li>
                            you must cease all use of the Software and delete
                            all access from your systems, devices, and account.
                          </li>
                        </ol>
                      </li>
                      <li>
                        Termination will not limit any of Company's rights or
                        remedies at law or in equity.
                      </li>
                    </ol>
                  </li>
                  <li>
                    <strong>DISCLAIMER OF WARRANTIES:-</strong>THE SOFTWARE IS
                    PROVIDED TO END USER "AS IS" AND WITH ALL FAULTS AND DEFECTS
                    WITHOUT WARRANTY OF ANY KIND. TO THE MAXIMUM EXTENT
                    PERMITTED UNDER APPLICABLE LAW, COMPANY, ON ITS OWN BEHALF
                    AND ON BEHALF OF ITS AFFILIATES AND ITS AND THEIR RESPECTIVE
                    LICENSORS AND SERVICE PROVIDERS, EXPRESSLY DISCLAIMS ALL
                    WARRANTIES, WHETHER EXPRESS, IMPLIED, STATUTORY, OR
                    OTHERWISE, WITH RESPECT TO THE SOFTWARE, INCLUDING ALL
                    IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                    PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT, AND
                    WARRANTIES THAT MAY ARISE OUT OF COURSE OF DEALING, COURSE
                    OF PERFORMANCE, USAGE, OR TRADE PRACTICE. WITHOUT LIMITATION
                    TO THE FOREGOING, COMPANY PROVIDES NO WARRANTY OR
                    UNDERTAKING, AND MAKES NO REPRESENTATION OF ANY KIND THAT
                    THE SOFTWARE WILL MEET YOUR REQUIREMENTS, ACHIEVE ANY
                    INTENDED RESULTS, BE COMPATIBLE, OR WORK WITH ANY OTHER
                    SOFTWARE, SYSTEMS, OR SERVICES, OPERATE WITHOUT
                    INTERRUPTION, MEET ANY PERFORMANCE OR RELIABILITY STANDARDS,
                    OR BE ERROR-FREE, OR THAT ANY ERRORS OR DEFECTS CAN OR WILL
                    BE CORRECTED.
                    <br />
                    SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF OR
                    LIMITATIONS ON IMPLIED WARRANTIES OR THE LIMITATIONS ON THE
                    APPLICABLE STATUTORY RIGHTS OF A CONSUMER, SO SOME OR ALL OF
                    THE ABOVE EXCLUSIONS AND LIMITATIONS MAY NOT APPLY TO YOU.
                  </li>
                  <li>
                    <strong>Limitation of Liability:-</strong>TO THE FULLEST
                    EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL COMPANY
                    OR ITS AFFILIATES, OR ANY OF ITS OR THEIR RESPECTIVE
                    LICENSORS OR SERVICE PROVIDERS, HAVE ANY LIABILITY ARISING
                    FROM OR RELATED TO YOUR USE OF OR INABILITY TO USE THE
                    SOFTWARE OR THE CONTENT AND SERVICES FOR
                    <br />
                    <ol type="a">
                      <li>
                        PERSONAL INJURY, PROPERTY DAMAGE, LOST PROFITS, COST OF
                        SUBSTITUTE GOODS OR SERVICES, LOSS OF DATA, LOSS OF
                        GOODWILL, BUSINESS INTERRUPTION, COMPUTER FAILURE OR
                        MALFUNCTION, OR ANY OTHER CONSEQUENTIAL, INCIDENTAL,
                        INDIRECT, EXEMPLARY, SPECIAL, OR PUNITIVE DAMAGES
                      </li>
                      <li>
                        DIRECT DAMAGES IN AMOUNTS THAT IN THE AGGREGATE EXCEED
                        THE AMOUNT ACTUALLY PAID BY YOU FOR THE SOFTWARE
                        <br />
                        THE FOREGOING LIMITATIONS WILL APPLY WHETHER SUCH
                        DAMAGES ARISE OUT OF BREACH OF CONTRACT, TORT (INCLUDING
                        NEGLIGENCE), OR OTHERWISE AND REGARDLESS OF WHETHER SUCH
                        DAMAGES WERE FORESEEABLE OR COMPANY WAS ADVISED OF THE
                        POSSIBILITY OF SUCH DAMAGES. SOME JURISDICTIONS DO NOT
                        ALLOW CERTAIN LIMITATIONS OF LIABILITY SO SOME OR ALL OF
                        THE ABOVE LIMITATIONS OF LIABILITY MAY NOT APPLY TO YOU.
                      </li>
                    </ol>
                  </li>
                  <li>
                    <strong>Indemnification:-</strong>You agree to indemnify,
                    defend, and hold harmless Company and its officers,
                    directors, employees, agents, affiliates, successors, and
                    assigns from and against any and all losses, damages,
                    liabilities, deficiencies, claims, actions, judgments,
                    settlements, interest, awards, penalties, fines, costs, or
                    expenses of whatever kind, including reasonable attorneys'
                    fees, arising from or relating to your use or misuse of the
                    Software or your breach of this Agreement, including but not
                    limited to the content you submit or make available through
                    this Software.
                  </li>
                  <li>
                    <strong>Export Regulation:-</strong>The Software may be
                    subject to U.S. export control laws, including the Export
                    Control Reform Act and its associated regulations. You shall
                    not, directly or indirectly, export, re-export, or release
                    the Software to, or make the Software accessible from, any
                    jurisdiction or country to which export, re-export, or
                    release is prohibited by law, rule, or regulation. You shall
                    comply with all applicable federal laws, regulations, and
                    rules, and complete all required undertakings (including
                    obtaining any necessary export license or other governmental
                    approval), prior to exporting, re-exporting, releasing, or
                    otherwise making the Software available outside the U.S.
                  </li>
                  <li>
                    <strong>Severability:-</strong>If any provision of this
                    Agreement is illegal or unenforceable under applicable law,
                    the remainder of the provision will be amended to achieve as
                    closely as possible the effect of the original term and all
                    other provisions of this Agreement will continue in full
                    force and effect; provided, however, that if any fundamental
                    term or provision of this Agreement, is invalid, illegal, or
                    unenforceable, the remainder of this Agreement shall be
                    unenforceable.
                  </li>
                  <li>
                    <strong>Governing Law:-</strong>This Agreement is governed by
                    and construed in accordance with the internal laws of the
                    State of Florida without giving effect to any choice or
                    conflict of law provision or rule. Any legal suit, action,
                    or proceeding arising out of or related to this Agreement or
                    the Software shall be instituted exclusively in the federal
                    courts of the United States or the courts of the State of
                    Florida in each case located in the county of Broward. You
                    waive any and all objections to the exercise of jurisdiction
                    over you by such courts and to venue in such courts.
                  </li>
                  <li>
                    <strong>Entire Agreement:-</strong>This Agreement, the Terms
                    of Use and the Privacy Policy constitute the entire
                    agreement between you and Company with respect to the
                    subject matter thereof and supersede all prior or
                    contemporaneous understandings and agreements, whether
                    written or oral, with respect to such subject matter.
                  </li>
                  <li>
                    <strong>Waiver:-</strong>No failure to exercise, and no delay
                    in exercising, on the part of either party, any right or any
                    power hereunder shall operate as a waiver thereof, nor shall
                    any single or partial exercise of any right or power
                    hereunder preclude further exercise of that or any other
                    right hereunder. In the event of a conflict between this
                    Agreement and any applicable purchase or other terms, the
                    terms of this Agreement shall govern.
                  </li>
                </ol>
              </Col>
            </Row>
          </div>
          <div className="modal-footer d-flex justify-content-between">
          <div class="form-group form-check ml-4">
            <label class="form-check-label">
              <input class="form-check-input"
                 value={isAgree} 
                 type="checkbox"
                 checked={isAgree}
                 onChange={() =>  this.handleAgreementCheckbox()}
                 /> 
                 <strong>I agree to end user license agreement.</strong>
            </label>
          </div>
            <Button
              color="primary"
              type="button"
              disabled={isAgree == 0}
              onClick={() => this.handleAgreementSubmit()}
            >
              Submit
            </Button>
          </div>
        </Modal>
        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="fas fa-home h2"></i>
          </Link>
        </div>
        <div className="login-page account-pages main-login my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={12} lg={12} xl={12}>
                <Card className="overflow-hidden logincircle">
                  <img
                    src={circleLogo}
                    alt=""
                    className="img-fluid circlelogo rotating"
                  />
                  <div className="innercircle">
                    <div className="bg-soft-primary">
                      <Row className="align-items-center">
                        <Col className="col-12 align-self-end loginlogo text-center">
                          <img
                            src={animateLogo2}
                            alt=""
                            className="img-fluid"
                          />
                        </Col>
                        <Col className="col-12 text-center">
                          <div className="text-primary p-4">
                            <h5 className="text-primary">Welcome Back !</h5>
                            <p>Sign in to continue to WookAI.</p>
                            <p className="freshmessage">
                              How to Keep WookAI Fresh!{" "}
                              <i
                                className="fa fa-info-circle"
                                aria-hidden="true"
                              ></i>
                              <div className="ballon">
                                <img
                                  src={bubble}
                                  alt=""
                                  className="messageimg"
                                />
                                <img
                                  src={bubbleMobile}
                                  alt=""
                                  className="msgmobile"
                                />

                                <div className="ballon_inner">
                                  <p>
                                    We are always improving WookAI. To keep me
                                    running at optimal performance, hard refresh
                                    your browser regularly with the keyboard
                                    combo, Control, Shift and the R button,
                                    prior to login !
                                  </p>
                                  <div className="triangle"></div>
                                </div>
                              </div>
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <CardBody className="pt-0">
                      <div className="d-none">
                        <Link to="/">
                          <div className="avatar-md profile-user-wid mb-4">
                            <span className="avatar-title rounded-circle bg-light">
                              <img
                                src={logo}
                                alt=""
                                className="rounded-circle"
                                height="34"
                              />
                            </span>
                          </div>
                        </Link>
                      </div>

                      <div className="p-2 inner-wrap">
                        <AvForm
                          className="form-horizontal"
                          onValidSubmit={(e, v) => {
                            this.handleValidSubmit(e, v);
                          }}
                        >
                          {this.props.error && this.props.error ? (
                            <Alert color="danger">{this.props.error}</Alert>
                          ) : null}

                          <div className="form-group">
                            <AvField
                              name="email"
                              // label='Email'
                              value={email}
                              className="form-control"
                              placeholder="Enter email"
                              type="email"
                              required
                              onChange={(e) =>
                                this.setState({ email: e.target.value })
                              }
                            />
                          </div>

                          <div className="form-group">
                            <AvField
                              name="password"
                              // label='Password'
                              value={password}
                              type="password"
                              required
                              placeholder="Enter password"
                              onChange={(e) =>
                                this.setState({ password: e.target.value })
                              }
                            />
                          </div>

                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="customControlInline"
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="customControlInline"
                            >
                              Remember me
                            </label>
                          </div>

                          <div className="mt-3">
                            <button
                              className="btn btn-primary btn-block waves-effect waves-light"
                              type="submit"
                            >
                              Log In
                            </button>
                          </div>

                          <div className="mt-4 text-center">
                            <Link to="/forgot-password" className="text-muted">
                              <i className="mdi mdi-lock mr-1"></i> Forgot your
                              password?
                            </Link>
                          </div>
                        </AvForm>
                      </div>
                    </CardBody>
                  </div>
                </Card>

                <div className=" text-center">
                  <p>
                    Don't have an account ?{" "}
                    <Link
                      to="register"
                      className="font-weight-medium text-primary"
                    >
                      {" "}
                      Signup now{" "}
                    </Link>{" "}
                  </p>
                  <p>
                    © {new Date().getFullYear()} WookAI.
                    {/* Crafted with{' '}
                    <i className='mdi mdi-heart text-danger'></i> by Themesbrand */}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const { error, isAgree, isModal } = state.Login;
  return { error, isAgree, isModal };
};

export default withRouter(
  connect(mapStatetoProps, { loginUser, agreement, apiError, agreementCheckbox })(Login)
);
